import { toast } from "react-toastify";
import { DeclineBooking, GetBookingData, GetBookingFilter } from "../api/services/booking";
import { GetPrePackage } from "../api/services/package";

export function useBooking () {

    const getBookingData = async (page: number, limit: number) => {

        const response = await GetBookingData(page, limit);
        console.log('response', response)
        const { message, status, errors } = response;
        if (status === 200) {
            message && toast["success"](message);
          
        } else {
            message && toast["error"](message);
        }
    
        return response;
      };

      const getBookingFiltered = async (page: number, limit: number, title:string, referenceCode:string, startingDate:string, endingDate:string) => {

        const response = await GetBookingFilter(page, limit, title, referenceCode, startingDate,endingDate  );
        console.log('response', response)
        const { message, status, errors } = response;
        if (status === 200) {
            message && toast["success"](message);
          
        } else {
            message && toast["error"](message);
        }
    
        return response;
      };

      const declineBooking = async (id:string): Promise<any> => {
        try {
          console.log("query", id);
          const response = await DeclineBooking( id);
          console.log("responseupdate", response);
          const {message, success, specialOffer, errors,status} = response
          if (status == 200)
          {
            message && toast["success"](message);
    
          }
          message && toast["error"](message);
      
          return response;
        } catch (error) {
          console.error("Error in getPackageById:", error);
          throw error;
        }
      };


   return {
    getBookingData,
    declineBooking,
    getBookingFiltered

   }   
    
}

